import React from 'react';
import {GoogleLoginButton} from 'react-social-login-buttons';

export default function GoogleSignInButton({onPress}) {
  return <GoogleLoginButton onClick={() => onPress()} />;
}
